import { render, staticRenderFns } from "./LocalizarCliente.vue?vue&type=template&id=a80a80da&scoped=true"
import script from "./LocalizarCliente.vue?vue&type=script&lang=js"
export * from "./LocalizarCliente.vue?vue&type=script&lang=js"
import style0 from "./LocalizarCliente.vue?vue&type=style&index=0&id=a80a80da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80a80da",
  null
  
)

export default component.exports